import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import {
  Panel,
  Message,
  Grid,
  Row,
  Col,
  Input,
  Slider,
  SelectPicker,
  ControlLabel,
  Button,
} from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import './styles.less'
import CKEditorBlankFrom from '../../components/forms/input/CKEditorBlankFrom'
import InputForm from '../../components/forms/input/InputForm'
import { isRequired } from '../../utils/ValidatorUtils'
import classNames from 'classnames'
import { cloneDeep } from 'lodash-es'
import {
  getProgressReportSubprojectClose,
  saveProgress,
} from '../../redux/actions/progressReportSubproject'
import notification from '../../utils/notification'
import { doneLoading, startLoading } from '../../utils/loading'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import { v4 as uuidv4 } from 'uuid'
import { useDispatch } from 'react-redux'
import { getSchemaSubProjectDep6Sidebar } from '../../redux/actions/sidebar'

export default function ProgressReportWidget({
  schema: _schema,
  isReadOnly,
  period,
  projectCode,
  projectVersionId,
  progressReportsId,
  setProgressReportsId = () => {},
  installmentPlanId,
  disabled,
  ...props
}) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, getValues, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [sliderValue, setSliderValue] = useState(0)
  const [progressValue, setProgressValue] = useState([])
  const [deleteId, setDeleteId] = useState([])
  const [mapValues, setMapValues] = useState(new Map())
  const projectId = sessionStorage.getItem('projectId')
  const dispatch = useDispatch()

  useEffect(() => {
    setFormSchema(_schema)
    setSliderValue(_schema?.sliderInput?.defaultValue || 0)
    setProgressValue(_schema?.affectingOperations?.values || null)
    setDataToMap(_schema?.affectingOperations?.values)
  }, [_schema])

  const setDataToMap = (value) => {
    var objMap = new Map()
    value?.forEach((e) => {
      objMap.set(e.id, e)
    })
    setMapValues(objMap)
  }

  const onSubmit = (data) => {
    let combinedData = []
    progressValue?.forEach((i) => {
      let mapval = mapValues.get(i.id)

      combinedData.push({
        progressObstaclesId:
          mapval.id === null ? '' : mapval.id.indexOf('addNew-') == -1 ? mapval.id : '',
        obstacles: mapval.issue,
        reason: mapval.reason,
        actionGuidelines: mapval.solutions,
      })
    })

    const request = {
      projectVersionId: projectVersionId || '',
      projectCode: projectCode || '',
      period: period,
      installmentPlanDetailId: installmentPlanId,
      progressReportsId: progressReportsId || '',
      progresPercentage: data.sliderInput || 0,
      progressObstaclesLists: combinedData,
      deleteObstaclesIds: deleteId || [],
    }

    handleCallService(request)
  }

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError()

    try {
      const response = await saveProgress(request)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        setProgressReportsId(response.progressReportsId)
        handleGetSchema()
        await dispatch(getSchemaSubProjectDep6Sidebar(projectId))
      } else {
        setErrorMsg({ type: 'error', description: response.errorMessage })
      }
    } catch (error) {
      console.error('try catch error ', error)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleGetSchema = async () => {
    startLoading()
    try {
      const response = await getProgressReportSubprojectClose(
        period,
        projectCode,
        projectVersionId,
        installmentPlanId
      )

      if (response) {
        setFormSchema(response?.forms?.progress)
        setProgressValue(response?.forms?.progress?.affectingOperations?.values || null)
        setDataToMap(response?.forms?.progress?.affectingOperations?.values)
      }
    } catch (e) {
      console.log(' error', e)
    }
    doneLoading()
  }

  const handleAdd = () => {
    let progressVal = cloneDeep(progressValue)
    let mapVal = cloneDeep(mapValues)
    let data = {
      id: 'addNew-' + uuidv4(),
      issue: '',
      reason: '',
      solutions: '',
    }
    progressVal.push(data)
    mapVal.set(data.id, data)
    setMapValues(mapVal)
    setProgressValue(progressVal)
  }

  const handleDelete = (item, index) => {
    let progressVal = cloneDeep(progressValue)
    let mapVal = cloneDeep(mapValues)

    if (index > -1) {
      progressVal.splice(index, 1)
    }
    if (!item.id.startsWith('addNew-')) {
      setDeleteId([...deleteId, item.id])
    }
    mapVal.delete(item.id)
    setMapValues(mapVal)
    setProgressValue(progressVal)
  }

  return (
    <>
      <Panel shaded header={formSchema.header} collapsible defaultExpanded>
        <Row style={{ marginTop: -20 }}>
          <Col lg={24} md={24} sm={24} xs={24}>
            <div style={{ paddingLeft: 20, paddingRight: 25 }}>
              <div>
                <h6>{formSchema.subtitle}</h6>
                <div
                  className="slider"
                  style={{ paddingLeft: 25, paddingRight: 30, marginTop: 20 }}
                >
                  <div
                    style={{ marginBottom: 20 }}
                    dangerouslySetInnerHTML={{
                      __html: `${formSchema.sliderInput.label} <b>( ${sliderValue}% )</b>`,
                    }}
                  />
                  <Controller
                    name={formSchema?.sliderInput?.name}
                    control={control}
                    defaultValue={_schema?.sliderInput?.defaultValue}
                    render={(props) => {
                      return (
                        <Slider
                          disabled={formSchema?.sliderInput?.disable}
                          tooltip={false}
                          value={sliderValue}
                          min={formSchema?.sliderInput?.min || 0}
                          step={formSchema?.sliderInput?.step || 10}
                          max={formSchema?.sliderInput?.max || 100}
                          graduated
                          progress
                          renderMark={(mark) => {
                            return `${mark} %`
                          }}
                          onChange={(value, e) => {
                            props.onChange(value)
                            setSliderValue(value)
                          }}
                        />
                      )
                    }}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>

        {progressValue &&
          progressValue.map((item, index) => {
            return (
              <>
                <Row style={{ marginTop: 30 }}>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <div style={{ paddingLeft: 40, paddingRight: 25 }}>
                      <h6>{`${index + 1}. ${formSchema.affectingOperations.title}`}</h6>
                    </div>
                  </Col>
                </Row>

                <div style={{ paddingLeft: 70, paddingRight: 20 }}>
                  <Row style={{ marginTop: 10 }}>
                    <Col lg={22} md={22} sm={22} xs={22}>
                      {!disabled ? (
                        <>
                          <ControlLabel
                            className={classNames(
                              isRequired(formSchema.affectingOperations.issueInput.validators) &&
                                'required'
                            )}
                          >
                            {formSchema.affectingOperations.issueInput.label}
                          </ControlLabel>

                          {/* <InputForm
                            schema={formSchema.affectingOperations.issueInput}
                            name={`${formSchema.affectingOperations.issueInput.name}_${item.id}`}
                            placeholder={'ระบุ' + formSchema.affectingOperations.issueInput.label}
                            register={register}
                            Controller={Controller}
                            control={control}
                            errors={errors}
                            setValue={setValue}
                            clearErrors={clearErrors}
                            hideLabel={true}
                            value={mapValues?.get(item.id)?.issue}
                            onChange={(value) => {
                              let nObj = cloneDeep(mapValues)
                              nObj.get(item.id).issue = value
                              setMapValues(nObj)
                            }}
                          /> */}
                          <InputForm
                            schema={formSchema.affectingOperations.issueInput}
                            name={`${formSchema.affectingOperations.issueInput.name}_${item.id}`}
                            register={register}
                            Controller={Controller}
                            control={control}
                            errors={errors}
                            setValue={setValue}
                            clearErrors={clearErrors}
                            hideLabel={true}
                            componentClass="textarea"
                            value={mapValues?.get(item.id)?.issue}
                            onChange={(value) => {
                              let nObj = cloneDeep(mapValues)
                              nObj.get(item.id).issue = value
                              setMapValues(nObj)
                            }}
                          />
                        </>
                      ) : (
                        <>
                          <b>{formSchema.affectingOperations.issueInput.label}</b>
                          <p>{mapValues?.get(item.id)?.issue}</p>
                        </>
                      )}
                    </Col>
                    <Col lg={2} md={2} sm={2} xs={2}></Col>
                  </Row>

                  <Row style={{ marginTop: 10 }}>
                    <Col lg={22} md={22} sm={22} xs={22}>
                      {!disabled ? (
                        <>
                          <ControlLabel
                            className={classNames(
                              isRequired(formSchema.affectingOperations.reasonInput.validators) &&
                                'required'
                            )}
                          >
                            {formSchema.affectingOperations.reasonInput.label}
                          </ControlLabel>

                          {/* <InputForm
                            schema={formSchema.affectingOperations.reasonInput}
                            name={`${formSchema.affectingOperations.reasonInput.name}_${item.id}`}
                            placeholder={'ระบุ' + formSchema.affectingOperations.reasonInput.label}
                            register={register}
                            Controller={Controller}
                            control={control}
                            errors={errors}
                            setValue={setValue}
                            clearErrors={clearErrors}
                            hideLabel={true}
                            value={mapValues?.get(item.id)?.reason}
                            onChange={(value) => {
                              let nObj = cloneDeep(mapValues)
                              nObj.get(item.id).reason = value
                              setMapValues(nObj)
                            }}
                          /> */}
                          <InputForm
                            schema={formSchema.affectingOperations.reasonInput}
                            name={`${formSchema.affectingOperations.reasonInput.name}_${item.id}`}
                            register={register}
                            Controller={Controller}
                            control={control}
                            errors={errors}
                            setValue={setValue}
                            clearErrors={clearErrors}
                            hideLabel={true}
                            componentClass="textarea"
                            value={mapValues?.get(item.id)?.reason}
                            onChange={(value) => {
                              let nObj = cloneDeep(mapValues)
                              nObj.get(item.id).reason = value
                              setMapValues(nObj)
                            }}
                          />
                        </>
                      ) : (
                        <>
                          <b> {formSchema.affectingOperations.reasonInput.label}</b>
                          <p>{mapValues?.get(item.id)?.reason}</p>
                        </>
                      )}
                    </Col>
                    <Col lg={2} md={2} sm={2} xs={2}></Col>
                  </Row>

                  <Row style={{ marginTop: 10 }}>
                    <Col lg={22} md={22} sm={22} xs={22}>
                      {!disabled ? (
                        <>
                          <ControlLabel
                            className={classNames(
                              isRequired(
                                formSchema.affectingOperations.solutionsInput.validators
                              ) && 'required'
                            )}
                          >
                            {formSchema.affectingOperations.solutionsInput.label}
                          </ControlLabel>

                          <InputForm
                            schema={formSchema.affectingOperations.solutionsInput}
                            name={`${formSchema.affectingOperations.solutionsInput.name}_${item.id}`}
                            register={register}
                            Controller={Controller}
                            control={control}
                            errors={errors}
                            setValue={setValue}
                            clearErrors={clearErrors}
                            hideLabel={true}
                            componentClass="textarea"
                            value={mapValues?.get(item.id)?.solutions}
                            onChange={(value) => {
                              let nObj = cloneDeep(mapValues)
                              nObj.get(item.id).solutions = value
                              setMapValues(nObj)
                            }}
                          />
                        </>
                      ) : (
                        <>
                          <b> {formSchema.affectingOperations.solutionsInput.label}</b>
                          <p>{mapValues?.get(item.id)?.solutions}</p>
                        </>
                      )}
                    </Col>
                    {!disabled ? (
                      <Col lg={2} md={2} sm={2} xs={2}>
                        {progressValue.length > 1 && (
                          <div style={{ marginTop: 33 }}>
                            <Button color="red" onClick={() => handleDelete(item, index)}>
                              ลบ
                            </Button>
                          </div>
                        )}

                        {progressValue.length == index + 1 && (
                          <>
                            <div style={{ marginTop: 33 }}>
                              <Button color="blue" onClick={() => handleAdd()}>
                                เพิ่ม
                              </Button>
                            </div>
                          </>
                        )}
                      </Col>
                    ) : (
                      <Col lg={2} md={2} sm={2} xs={2}></Col>
                    )}
                  </Row>
                </div>
              </>
            )
          })}
        {!disabled && (
          <Row style={{ marginTop: 20 }}>
            <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <div style={{ paddingLeft: 40, paddingRight: 25 }}>
                <SaveButton disabled={isLoading} onClick={handleSubmit(onSubmit)}>
                  บันทึก
                </SaveButton>
              </div>
            </Col>
          </Row>
        )}
      </Panel>
    </>
  )
}
